import React from 'react';

import { Box, Typography } from '@mui/material';

import { Button } from 'src/components/common';
import { CheckboxField, Field, Form } from 'src/components/finalForm';

export const CheckboxInputSection: React.FC = () => {
  return (
    <Box component="section">
      <Typography variant="h3">Checkbox Input</Typography>

      <Box mt={2}>
        <Form onSubmit={submitHandler} initialValues={initialValue} subscription={{ dirty: true }}>
          {({ form, dirty }) => (
            <React.Fragment>
              <Box>
                <Field
                  name={FormFieldId.simpleCheckbox}
                  component={CheckboxField}
                  label="Simple checkbox"
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.selectedCheckbox}
                  component={CheckboxField}
                  label="Selected checkbox"
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.indeterminateCheckbox}
                  component={CheckboxField}
                  label="Indeterminate checkbox"
                  indeterminate
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.disabledCheckbox}
                  component={CheckboxField}
                  label="Disabled checkbox"
                  disabled
                />
              </Box>

              <Box>
                <Field
                  name={FormFieldId.selectedDisabledCheckbox}
                  component={CheckboxField}
                  label="Disabled selected checkbox"
                  disabled
                />
              </Box>

              <Box mt={2}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => form.restart()}
                  disabled={!dirty}
                >
                  Reset
                </Button>
              </Box>
            </React.Fragment>
          )}
        </Form>
      </Box>
    </Box>
  );
};

enum FormFieldId {
  simpleCheckbox = 'simpleCheckbox',
  selectedCheckbox = 'selectedCheckbox',
  indeterminateCheckbox = 'indeterminateCheckbox',
  disabledCheckbox = 'disabledCheckbox',
  selectedDisabledCheckbox = 'selectedDisabledCheckbox',
}

const initialValue = {
  [FormFieldId.simpleCheckbox]: false,
  [FormFieldId.selectedCheckbox]: true,
  [FormFieldId.indeterminateCheckbox]: true,
  [FormFieldId.disabledCheckbox]: false,
  [FormFieldId.selectedDisabledCheckbox]: true,
};

const submitHandler = () => undefined;
